import React from 'react';
import { LatLng } from 'leaflet';

import { getDistanciaHumanized } from '../../util/camera';

import {
  fechaModalBuscaCameras,
  changeFiltroCameras,
  selecionaCamera,
  updateVideoUrl,
} from '../../actions';

import CameraThumb from '../CameraThumb';
import ModalBuscaCamerasFilter from './Filter';
import BotaoFechar from '../BotaoFechar';

import './style.css';
import { connect } from 'react-redux';

const ModalBuscaCameras = (props) => {

  const referencia = new LatLng(props.localizacao[0], props.localizacao[1]);

  let cameras = getFilteredCameras(
    props.cameras,
    props.buscaCamerasFiltro,
  ).map(camera => {
    camera.distancia = referencia.distanceTo(new LatLng(camera.coordenadas[0], camera.coordenadas[1]));
    return camera;
  })
  //.filter(camera => camera.publicOnCop)
  .sort((a, b) => a.distancia - b.distancia);

  return (
    <div className="overlay">
      <div className="container text-center">
        <ModalBuscaCamerasFilter
          onFilterChange={ props.changeFiltroCameras }
        />

        <div className="pull-right mt-4">
          <BotaoFechar onClick={ () => props.fechaModalBuscaCameras() } />
        </div>
        <p className="total-cameras">Foram encontradas { cameras.length } câmeras</p>
        <div className="results">
          {
            cameras.map((camera, index) =>
              <ThumbAndDescription
                camera={camera}
                key={index}
                onClick={ () => {
                  props.updateVideoUrl(camera.videoUrl);
                  props.selecionaCamera(camera);
                  props.fechaModalBuscaCameras();
                }} />
            )
          }
        </div>
      </div>
    </div>
  );
};

const getFilteredCameras = (cameras, filtro) => {
  filtro = new RegExp(filtro.toLowerCase());

  const match = (camera, filtro) => (
    camera.location.toLowerCase().match(filtro) ||
    camera.description.toLowerCase().match(filtro)
  );

  return cameras.filter(camera => match(camera, filtro));
};

const ThumbAndDescription = ({ camera, onClick }) => (
  <div className="thumb-and-description" onClick={ () => onClick() }>
    <CameraThumb camera={camera} />
    <div className="description">
      <p>{ getDistanciaHumanized(camera.distancia) }</p>
      <p>{ camera.description }</p>
      <p className="small">{ camera.location }</p>
    </div>
  </div>
);

const mapStateToProps = (state) => ({
  buscaCamerasFiltro: state.buscaCamerasFiltro,
  cameras: state.cameras,
  localizacao: state.localizacao,
});
const mapDispatchToProps = ({
  fechaModalBuscaCameras,
  changeFiltroCameras,
  selecionaCamera,
  updateVideoUrl,
});
export default connect(mapStateToProps, mapDispatchToProps)(ModalBuscaCameras);



// WEBPACK FOOTER //
// ./src/components/ModalBuscaCameras/index.js